import { createFeatureSelector, createSelector } from "@ngrx/store";
import { HeaderCommonStore } from "../interfaces/header-common-store";

export const headerStateSelector = createFeatureSelector<HeaderCommonStore>('commonHeader');
export const locationSelector = createSelector(headerStateSelector, (state: HeaderCommonStore) => state.previousRoute)